import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Modal,
    Form,
    Input,
    Dimmer,
    Loader,
    Message,
    Popup
} from "semantic-ui-react";
import ButtonHandler from "../../ButtonHandler.jsx";
import processIcon from "../../../Images/process.png";
import config from "../../../config.js";
import excel from "../../../Images/excel_icon.png";
import CheckboxTable from "../../ControlPanelComponents/CheckboxView.jsx";
import {
    fetchAutomationStatusData, runSmartspotAutomationScript, fetchUseraction,
    getDisbursementFormulas, updateDisbursementFormulas, fetchTemplates,
    getWorkingFiles, rawFileProcess, getsplittedFiles, getSplitFilesFormulas,
    updateSplitFileFormulas,
    processApprovedFiles,
    splitSitewiseProcess,
    sendWorkingFiles,
    processCreditNote,
    sendCreditNoteFiles,
    splitLatIncentivesScript,
    getLatSplitFiles,
    sendLatWorkingFiles,
    updateMailContent,
    updateDistInfo,
    getLatSplitStatus,
    subdPiFinalWorkingFiles,
    subdPiFinalWorkingFilesStatus,
    getSubdpiLocationsData,
    getSubdpiPeriodsData,
    addSubdPiPeriodsData,
    getWholesalDisbursementFormulas,
    wholesaleIpdateDisbursementFormulas,
    sendApprovalEmailToPandG
} from '../../../actions/users_action';

var apiTimeout = null
class SubdPI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            automationStatus: 'Pending',
            initial: true,
            outputUrl: '',
            downloadEnable: false,
            templateId: "",
            distributors: [],
            selectedDistributor: '',
            formulaModalOpen: false,
            formulas: [],
            selectedTemplate: '',
            templates: [],
            automationSplitFiles: [],
            modalOpen: false,
            fileUploaded: false,
            fileName: '',
            currentFile: {},
            workingFiles: [],
            auditingSplit: [],
            nonAuditingSplit: [],
            formulasType: '',
            loaderStatus: false,
            selectedDist: {},
            disType: 'subdPi',
            splitFilesList: [],
            mailcontentModalOpen: false,
            megSubject: '',
            megBody: '',
            periodModalOpen: false,
            locationList: [],
            overallLocationPeriods: [],
            releaseAlertMoalOpen: false
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'], fileTemplates: res.templates[res.templates.length - 1]['fileTemplates'] })
                this.props.getWorkingFiles(res.templates[res.templates.length - 1]['_id'], 'SUBDPI', {
                    onSuccess: (res) => {
                        if (res.workingFiles.length > 0) {
                            res.workingFiles.map((d) => {
                                this.setState({ megBody: d.megBody, megSubject: d.megSubject })
                            })
                            this.setState({ workingFiles: res.workingFiles })
                        }
                        else {
                            this.setState({ megBody: '', megSubject: '' })
                        }
                    },
                    onFailure: () => {

                    }
                })
                let data = {
                    templateId: res.templates[res.templates.length - 1]['_id'],
                    fileName: 'SUBDPI'
                }
                this.props.getLatSplitFiles(data, {
                    onSuccess: (res) => {
                        if (res.files_list.length > 0) {
                            this.setState({ splitFilesList: res.files_list, splitBtn: true })
                        }
                        else {
                            this.setState({ splitFilesList: [], splitBtn: false })
                        }

                    },
                    onFailure: () => {

                    }
                })

                this.props.subdPiFinalWorkingFilesStatus(data, {
                    onSuccess: (res) => {
                        if (res.master.fileStatus == 'Completed') {
                            this.setState({ automationStatus: 'Completed', outputUrl: res.master.result[0], downloadEnable: true, initial: false })
                        }
                    },
                    onFailure: () => {

                    }
                })
            },
            onFailure: () => {
            }
        })

    }

    start = () => {
        this.setState({
            automationStatus: 'Processing',
            initial: false
        })

        let data = {
            templateId: this.state.templateId,
            fileName: 'SUBDPI'
        }

        this.props.subdPiFinalWorkingFiles(data, {
            onSuccess: () => {
                apiTimeout = setTimeout(this.loadFinalData, 3000)
            },
            onFailure: () => {

            }
        })
    }

    loadFinalData = () => {
        let data = {
            templateId: this.state.templateId,
            fileName: 'SUBDPI'
        }
        this.props.subdPiFinalWorkingFilesStatus(data, {
            onSuccess: (res) => {
                console.log(res.master.fileStatus, 'status')
                if (res.master.fileStatus == 'Completed') {
                    this.setState({ automationStatus: 'Completed', outputUrl: res.master.result[0], downloadEnable: true, initial: false })
                    clearTimeout(apiTimeout)
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadFinalData, 3000)
    }

    loadData = () => {
        // this.setState({ loaderStatus: true })
        let data = {
            templateId: this.state.templateId,
            fileName: 'SUBDPI'
        }
        this.props.getLatSplitStatus(data, {
            onSuccess: (res) => {
                if (res.master.splitStatus == 'Completed') {
                    clearTimeout(apiTimeout)
                    this.props.updateDistInfo(data, {
                        onSuccess: () => {
                            this.setState({ loaderStatus: false })
                            let data = {
                                templateId: this.state.templateId,
                                fileName: 'SUBDPI'
                            }
                            this.props.getLatSplitFiles(data, {
                                onSuccess: (res) => {
                                    if (res.files_list.length > 0) {
                                        this.setState({ splitFilesList: res.files_list, splitBtn: true })
                                    }
                                    else {
                                        this.setState({ splitFilesList: [], splitBtn: false })
                                    }

                                },
                                onFailure: () => {

                                }
                            })
                        },
                        onFailure: () => {

                        }
                    })

                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadData, 3000)
    }

    downloadfile = (url) => {
        window.open(url);
    }

    dropDownDistributorOnChange = (e, data) => {
        this.setState({ selectedDistributor: data.value })
    }

    dropDownTemplateOnChange = (e, data) => {
        data.options.map((d) => {
            if (d.value == data.value) {
                this.setState({ templateId: d.key })
                let updatedData = {
                    templateId: d.key,
                    disType: 'SUBDPI'
                }
                this.props.getLatSplitFiles(d.key,'SUBDPI',{
                    onSuccess: (res) => {
                        if (res.files_list.length > 0) {
                            this.setState({ splitFilesList: res.files_list, splitBtn: true })
                        }
                        else {
                            this.setState({ splitFilesList: [], splitBtn: false })
                        }
                    },
                    onFailure: () => {

                    }
                })
                this.props.getWorkingFiles(d.key, 'SUBDPI', {
                    onSuccess: (res) => {
                        if (res.workingFiles.length > 0) {
                            res.workingFiles.map((d) => {
                                this.setState({ megBody: d.megBody, megSubject: d.megSubject })
                            })
                            this.setState({ workingFiles: res.workingFiles })
                        }
                        else {
                            this.setState({ megBody: '', megSubject: '', workingFiles: '' })
                        }
                    },
                    onFailure: () => {

                    }
                })

                let data = {
                    templateId: d.key,
                    fileName: 'SUBDPI'
                }

                this.props.subdPiFinalWorkingFilesStatus(data, {
                    onSuccess: (res) => {

                        if (res.master && res.master.fileStatus && res.master.fileStatus == 'Completed') {
                            this.setState({ automationStatus: 'Completed', outputUrl: res.master.result[0], downloadEnable: true, initial: false })
                        }
                        else {
                            this.setState({ automationStatus: 'Pending', downloadEnable: false, initial: true })
                        }
                    },
                    onFailure: () => {

                    }
                })
            }
        })
        this.setState({ selectedTemplate: data.value })
    }
    closeuploadoption = () => {
        this.setState({ modalOpen: false, mailcontentModalOpen: false, periodModalOpen: false, releaseAlertMoalOpen: false })
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0], fileUploaded: true })
    };

    uploadRawFile = () => {
        this.setState({ loaderStatus: true })
        this.props.rawFileProcess(this.state.currentFile, this.state.fileName, this.state.templateId, {
            onSuccess: () => {
                this.setState({ modalOpen: false, loaderStatus: false })
                alert("File Uploaded Successfully")
                this.props.getWorkingFiles(this.state.templateId, 'SUBDPI', {
                    onSuccess: (res) => {
                        console.log(res, 'response')
                        this.setState({ workingFiles: res.workingFiles })
                    },
                    onFailure: () => {

                    }
                })
            },
            onFailure: () => {

            }
        })
    }

    uploadFile = async (fileName, type) => {
        console.log(type, 'type')
        this.setState({ fileName: fileName, fileType: type, modalOpen: true })

    }

    splitFiles = async () => {
        this.setState({ loaderStatus: true })
        if (this.state.splitBtn == false) {

            let data = {
                templateId: this.state.templateId,
                fileName: 'SUBDPI'
            }

            await this.props.splitLatIncentivesScript(data, {
                onSuccess: (res) => {
                    apiTimeout = setTimeout(this.loadData, 3000)
                },
                onFailure: () => {
                }
            })
        }
        else {
            alert('Split Already Done')
        }
    }
    processApprovedFiles = () => {
        let templateId = this.state.templateId
        this.setState({ loaderStatus: true })
        this.props.processApprovedFiles(templateId, {
            onSuccess: () => {
                this.setState({ loaderStatus: false })
            },
            onFailure: () => {

            }
        })
    }

    siteData = (rowData, checkedValue) => {

        this.setState({ 'selectedDist': rowData })

    };

    sendedData = (rowData, row) => {
        this.setState({ 'selectedDist': rowData })
    };

    releaseWorking = () => {
        if (this.state.selectedDist.length !== 0) {
            this.setState({ loaderStatus: true })
            let data = {
                selectedDist: this.state.selectedDist,
                megBody: this.state.megBody,
                megSubject: this.state.megSubject,
                disType: 'SUBDPI',
                templateId: this.state.templateId
            }

            this.props.sendLatWorkingFiles(data, {
                onSuccess: () => {
                    this.setState({ loaderStatus: false })
                    alert('Working Files Released Successfully.Please check mails')
                },
                onFailure: () => {

                }
            })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    mailContentModal = () => {
        this.setState({ mailcontentModalOpen: true })
    }

    handleSubjectChange = (e) => {
        this.setState({ megSubject: e.target.value })
    }

    handleBodyChange = (e) => {
        this.setState({ megBody: e.target.value })
    }

    saveMegContent = () => {
        let data = {
            megBody: this.state.megBody,
            megSubject: this.state.megSubject,
            templateId: this.state.templateId,
            disType: 'SUBDPI'
        }
        this.props.updateMailContent(data, {
            onSuccess: (res) => {
                this.setState({ mailcontentModalOpen: false })
            },
            onFailure: () => {

            }
        })
    }

    formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${dd}-${mm}-${yyyy}`;
    };


    periodSelect = () => {
        let data = {
            templateId: this.state.templateId
        }
        this.setState({ loaderStatus: true })
        this.props.getSubdpiLocationsData(data, {
            onSuccess: (response) => {

                this.setState({ periodModalOpen: true, loaderStatus: false })

                this.props.getSubdpiPeriodsData(this.state.templateId, {
                    onSuccess: (res) => {
                        console.log(res.salesPeriodsData, 'salesData')
                        if (res.salesPeriodsData.length > 0) {
                            this.setState({ locationList: res.salesPeriodsData })
                        }
                        else {
                            let a = this.state.selectedTemplate;
                            let b = a.split("-")[1].replace(' ', '')
                            let month = b.split(" ")[0]
                            let year = b.split(" ")[1]
                            const firstDate = new Date(`${month} 1, ${year}`);
                            const fifteenthDate = new Date(`${month} 15, ${year}`);
                            let location_list = []
                            if (response.locations.length > 0) {
                                response.locations.map((loc) => {
                                    console.log(this.formatDate(firstDate), 'date')
                                    location_list.push({
                                        'location': loc,
                                        'startDate': this.formatDate(firstDate),
                                        'endDate': this.formatDate(fifteenthDate)
                                    })
                                })
                            }

                            this.setState({ locationList: location_list })

                        }
                    },
                    onFailure: () => {

                    }
                })


            },
            onFailure: () => {

            }
        })

    }

    handleStartDateChange = (e, location) => {
        let locationData = this.state.locationList
        locationData.map((loc) => {
            if (loc.location == location.location) {
                loc.startDate = e.target.value
            }
        })
        this.setState({ startDate: e.target.value, locationList: locationData })
    }

    handleEndDateChange = (e, location) => {
        let locationData = this.state.locationList
        locationData.map((loc) => {
            if (loc.location == location.location) {
                loc.endDate = e.target.value
            }
        })
        this.setState({ endDate: e.target.value, locationList: locationData })
    }

    savePeriodsData = () => {
        let data = {
            templateId: this.state.templateId,
            locationList: this.state.locationList
        }
        this.setState({ loaderStatus: true })
        this.props.addSubdPiPeriodsData(data, {
            onSuccess: (res) => {
                this.setState({ loaderStatus: false, periodModalOpen: false })
            },
            onFailure: () => {

            }
        })
    }

    formulasModal = (types) => {
        let type = {
            disType: 'SubdPI'
        }
        this.props.getWholesalDisbursementFormulas(type, {
            onSuccess: (res) => {
                console.log(res, 'res')
                let formulas_calc = res.data.formulas
                console.log(formulas_calc, 'formulas')
                this.setState({ formulas: formulas_calc })
            },
            onFailure: () => {

            }
        })
        this.setState({ formulaModalOpen: true })

    }

    formulaOnChange = (e, data) => {
        let formulas_data = this.state.formulas;
        formulas_data.map((d) => {
            if (Object.keys(d)[0] == Object.keys(data)[0]) {
                d[Object.keys(d)[0]] = e.target.value + '\n'
            }
        })
        this.setState({ formulas: formulas_data })
    }

    saveFormulas = () => {
        let data = {
            formulas: this.state.formulas,
            disType: 'SubDPI'
        }
        this.props.wholesaleIpdateDisbursementFormulas(data, {
            onSuccess: () => {
                this.setState({ formulaModalOpen: false })
                alert("Formulas File Updated")
            },
            onFailure: () => {

            }
        })
    }

    closeFormulaModal = () => {
        this.setState({ formulaModalOpen: false })
    }

    sendEmailforApproval = () => {
        this.setState({ loaderStatus: true })
        let data = {
            templateId: this.state.templateId,
            disType: "subdpi"
        }
        this.props.sendApprovalEmailToPandG(data, {
            onSuccess: (res) => {
                alert(res.status)
                this.setState({ loaderStatus: false })
            },
            onFailure: (res) => {
                alert(res.status)
                this.setState({ loaderStatus: false })
            }
        })
    }

    showReleaseConfirmationAlert = () => {
        if (this.state.selectedDist.length) {
            this.setState({ releaseAlertMoalOpen: true })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    render() {

        var templateMonths = []

        this.state.templates.map((d) => {
            templateMonths.push({
                'key': d._id,
                'value': d.name,
                'text': d.name
            })
        })

        const auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "Working Files",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile(original.fileUrl)}
                    />;
                },
            },
            {
                Header: "Releasing Date",
                accessor: "releasingDate",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.releasingDate}</span>;
                },
            },
            {
                Header: "Release Status",
                accessor: "workingReleaseCheck",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.workingReleaseCheck}</span>;
                },
            },
        ];


        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Dimmer active={this.state.loaderStatus}>
                        <Loader size="massive">File Processing.....</Loader>
                    </Dimmer>
                </div>

                {/* <br /> */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Template Month' search selection options={templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}
                        />
                    </div>
                    <div style={{ marginLeft: 20 }}>
                        <Button color='blue'
                            onClick={() => this.periodSelect()}
                        >
                            <Icon name="calendar" />
                            Period of Sales
                        </Button>
                    </div>

                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.uploadFile('subdpi-approvedFiles', 'subdpi-approvedFiles')}
                        >

                            Upload Files for P&G Approval
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>

                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.sendEmailforApproval()}
                        >

                            Send Email for P&G Approval
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>


                </div>

                <Grid columns={3} style={{ marginTop: 20 }}>

                    <GridColumn>
                        <Card.Group>
                            <h2 style={{ marginLeft: 10 }}>Final Disbursement Processing</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Description>
                                        <h4>{`Automation Status   `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: <strong style={{ color: this.state.automationStatus == 'Completed' ? 'green' : this.state.automationStatus == 'Processing' ? 'orange' : 'red' }}>{this.state.automationStatus}</strong></h4>
                                    </Card.Description>
                                    <br></br>

                                </Card.Content>
                                <Card.Content extra>

                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        {this.state.initial == true && (
                                            <Button basic color='green'
                                                onClick={() => this.start()}
                                            >
                                                <Icon name="hand point up" />
                                                Start
                                            </Button>
                                        )}
                                        {this.state.initial == false && (
                                            <Button basic color='orange'
                                                onClick={() => this.start()}
                                            >
                                                <Icon name="redo" />
                                                Re-Start
                                            </Button>
                                        )}
                                        {this.state.initial == false && (
                                            <Button basic color='green'
                                                onClick={() => this.downloadfile(this.state.outputUrl)}
                                                disabled={this.state.downloadEnable == true ? false : true}
                                            >
                                                <Icon name="download" />
                                                Download
                                            </Button>
                                        )}

                                    </div>

                                </Card.Content>
                            </Card>

                        </Card.Group>
                    </GridColumn>



                    <GridColumn>
                        <Card.Group>
                            <h2>Approved Disbursement</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    {/* Excel image + Notification icon */}
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                        
                                         <Popup
                                            trigger={
                                                <Icon
                                                    name="info circle"
                                                    color="blue"
                                                    size="large"
                                                    style={{ marginLeft: 8, cursor: 'pointer' }}
                                                />
                                            }
                                            on="click"
                                            position="bottom right"
                                            content={
                                                <Message positive>
                                                    <Message.Header>
                                                        Please Follow The Instruction Before Uploading File
                                                    </Message.Header>
                                                    <p>1. Uploaded file should have two sheets.</p>
                                                    <p>2. The sheet names should be "Summary" and "Workings".</p>
                                                    <p>3. Headers should be in the first row in both sheets.</p>
                                                    <p>4. Data should start from the second row.</p>
                                                </Message>
                                            }
                                        />
                                        <Image
                                            floated="right"
                                            size="mini"
                                            src={excel}
                                            style={{ cursor: 'pointer' }}
                                        />

                                        {/* Notification icon with popup */}
                                       
                                    </div>

                                    <br />
                                    <br />
                                    <br />

                                    <Card.Description style={{ marginTop: -20 }}>
                                        <h3
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            {'Approved File   '}
                                            <Icon
                                                name="upload"
                                                style={{ marginLeft: 65, cursor: 'pointer' }}
                                                color={'orange'}
                                                onClick={() => this.uploadFile('subdPi', 'SUBDPI')}
                                            />
                                            <Icon
                                                name="arrow circle down"
                                                style={{ marginLeft: 25, cursor: 'pointer' }}
                                                color={'green'}
                                                onClick={() =>
                                                    this.downloadfile(
                                                        this.state.workingFiles[0].result[0]
                                                    )
                                                }
                                            />
                                        </h3>
                                    </Card.Description>
                                </Card.Content>

                            </Card>
                        </Card.Group>
                    </GridColumn>

                </Grid>
                <br></br>
                <br></br>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <p style={{ fontSize: 25 }}>
                            <h1
                                style={{

                                    flex: "0 0 30px",
                                    display: "inline-block",
                                    color: "#2185d0",
                                }}
                            >
                                Disbursement Working for Sites
                            </h1>
                        </p>
                    </div>

                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.splitFiles()}
                        >

                            Split Files
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.mailContentModal()}
                        >

                            Mail Content
                            <Icon name="mail" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.showReleaseConfirmationAlert()}
                        >

                            Release Workings
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                </div>


                <p style={{ fontSize: 18 }}>
                    <h1
                        style={{

                            flex: "0 0 30px",
                            display: "inline-block",
                            color: "#0000000",
                        }}
                    >
                        Site Wise Files
                    </h1>
                </p>
                <CheckboxTable
                    data={this.state.splitFilesList}
                    columns={auditing_split_columns}
                    sendedData={this.siteData}
                />
                <br></br>
                <br></br>

                <Modal
                    open={this.state.releaseAlertMoalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <h1><b>Below Sites You're Choosing for Working Files Release Process </b></h1>
                            {this.state.selectedDist.length > 0 && this.state.selectedDist.map((d, index) => {
                                return (
                                    <>
                                        <h3>{index + 1}{'. '}{d.siteName}-{d.location}</h3>
                                    </>
                                )
                            })}
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.releaseWorking}
                                isIcon={true}
                                color={'green'}
                                iconName={'mail'}
                                iconColor={'white'}
                                title={'Send'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>


                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadRawFile}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileUploaded == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.formulaModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <strong>{`IF No formula for a column please specifiy the column as like "A -- No Formula"`}</strong>
                            {this.state.formulas.length > 0 && this.state.formulas.map((d) => {
                                return (
                                    <Grid columns={1}>
                                        <Grid.Row>
                                            <GridColumn style={{ marginTop: 20 }}>
                                                <Form.Input
                                                    type="any"
                                                    label={Object.keys(d)[0]}
                                                    value={Object.values(d)[0]}
                                                    onChange={(e) => this.formulaOnChange(e, d)}
                                                    placeholder={Object.values(d)[0]}
                                                />
                                            </GridColumn>
                                        </Grid.Row>
                                    </Grid>
                                )

                            })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.saveFormulas}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.mailcontentModalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.TextArea
                                            autoHeight
                                            onChange={this.handleSubjectChange}
                                            label="Mail Subject"
                                            value={this.state.megSubject}
                                            placeholder="Enter your request message"
                                            rows={2}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.TextArea
                                            autoHeight
                                            onChange={this.handleBodyChange}
                                            label="Mail Body"
                                            value={this.state.megBody}
                                            placeholder="Enter your request message"
                                            rows={5}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.saveMegContent}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.periodModalOpen}
                    onClose={this.closeuploadoption}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <h3><strong>{`Select a PSR sales date for each location.`}</strong></h3>
                            {console.log(this.state.locationList, 'locationList')}
                            {this.state.locationList.length > 0 && this.state.locationList.map((loc) => {
                                return (

                                    <Grid columns={3}>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Form.Input
                                                    type="any"
                                                    value={loc.location}
                                                    placeholder=""
                                                    editable={false}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Form.Input
                                                    type="any"
                                                    value={loc.startDate}
                                                    placeholder=""
                                                    onChange={(e) => this.handleStartDateChange(e, loc)}
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Form.Input
                                                    type="any"
                                                    value={loc.endDate}
                                                    placeholder=""
                                                    onChange={(e) => this.handleEndDateChange(e, loc)}
                                                />
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>

                                )
                            })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.savePeriodsData}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>

            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchAutomationStatusData,
            runSmartspotAutomationScript,
            fetchUseraction,
            getDisbursementFormulas,
            updateDisbursementFormulas,
            fetchTemplates,
            getWorkingFiles,
            rawFileProcess,
            getsplittedFiles,
            getSplitFilesFormulas,
            updateSplitFileFormulas,
            processApprovedFiles,
            splitSitewiseProcess,
            sendWorkingFiles,
            processCreditNote,
            sendCreditNoteFiles,
            splitLatIncentivesScript,
            getLatSplitFiles,
            sendLatWorkingFiles,
            updateMailContent,
            updateDistInfo,
            getLatSplitStatus,
            subdPiFinalWorkingFiles,
            subdPiFinalWorkingFilesStatus,
            getSubdpiLocationsData,
            getSubdpiPeriodsData,
            addSubdPiPeriodsData,
            getWholesalDisbursementFormulas,
            wholesaleIpdateDisbursementFormulas,
            sendApprovalEmailToPandG
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubdPI));
